import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39146dfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-dimension-inputs__full" }

import { computed } from "vue";
import debounce from "lodash/debounce";
import isUndefined from "lodash/isUndefined";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import TextToggle from "./TextToggle.vue";
import FontSelect from "./FontSelect.vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import InputLabel from "@/components/UI/InputLabel.vue";
import TextNotice from "@/components/UI/TextNotice.vue";
import { Props } from "@/components/ShapeType.vue";
import InfoCircleDark from "@/components/icons/InfoCircleDark.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix, modifierAction } = __props;

const dimensionLabel = computed(() => store.getters.dimensionLabel);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const dimensions = computed(() => store.getters.getMeasurements( 'text', isCutout ) );
const modifiers = computed(() => store.getters.getModifiers( isCutout ));
const isLoading = computed(() => store.getters.fontIsLoading );

const font = computed({
	get: () => modifiers.value.font,
	set: async(value: string) => {
		store.commit("updateLoadingState", true);
		store.commit(modifierAction, { modifier: "font", value });
		store.commit("setSelectedFont", value);
		store.commit("updateLoadingState", false);
	},
});

const text = computed({
	get: () => modifiers.value.text,
	set: async(value: string) => {
		store.commit("updateLoadingState", true);
		store.commit(modifierAction, { modifier: "text", value });
		store.commit("updateLoadingState", false);
	},
});

const desiredLength = computed({
	get: () => {
		if ( isUndefined( modifiers.value.text )|| isUndefined( dimensions.value ) ) {
			return 20;
		}

		return dimensions.value.desired_length;
	},
	set: async(value: string) => {
		store.commit("updateLoadingState", true);
		await store.dispatch(action, { dimension: "desired_length", value: value });
		store.commit("updateLoadingState", false);
	},
});

const desiredDimension = computed({
	get: () => modifiers.value.desired_dimension,
	set: async(value: string) => {
		store.commit("updateLoadingState", true);
		store.commit(modifierAction, { modifier: "desired_dimension", value });
		store.commit("updateLoadingState", false);
	},
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, { class: "text-dimension-inputs" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(InputLabel, {
          for: "measurements-text-font",
          class: "text-dimension-inputs__label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(dimensionLabel.value("font", "text")), 1)
          ]),
          _: 1
        }),
        _createVNode(FontSelect, {
          id: "measurements-text-font",
          modelValue: font.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((font).value = $event)),
          name: "measurements[modifiers][font]",
          key: "text-font"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(DimensionInput, {
        class: "text-dimension-inputs__full",
        id: "measurements-text-text",
        name: "measurements[modifiers][text]",
        label: dimensionLabel.value('text', 'text'),
        modelValue: text.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((text).value = $event)),
        onBlur:  () => _unref(addSizeToDataLayer)('text', +text.value, 'text'),
        invalid: !isDimensionValid.value('text-text'),
        isLoading: isLoading.value,
        readonly: isLoading.value === true,
        inputmode: "text",
        delay: 0
      }, null, 8, ["label", "modelValue", "onBlur", "invalid", "isLoading", "readonly"]),
      _createVNode(DimensionInput, {
        id: "measurements-text-desired_length",
        name: "measurements[dimensions][desired_length]",
        label: dimensionLabel.value(desiredDimension.value, 'text'),
        modelValue: desiredLength.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((desiredLength).value = $event)),
        onBlur:  () => _unref(addSizeToDataLayer)('desired_length', +desiredLength.value, 'text'),
        invalid: !isDimensionValid.value('text-desired_length'),
        unit: "cm"
      }, null, 8, ["label", "modelValue", "onBlur", "invalid"]),
      _createElementVNode("div", null, [
        _createVNode(InputLabel, {
          for: "measurements-text-desired_dimension-height",
          class: "text-dimension-inputs__label"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(dimensionLabel.value("desired_dimension", "text")), 1)
          ]),
          _: 1
        }),
        _createVNode(TextToggle, {
          name: "measurements[modifiers][desired_dimension]",
          idPrefix: "measurements-text-desired_dimension",
          valueA: "height",
          valueB: "width",
          modelValue: desiredDimension.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((desiredDimension).value = $event)),
          labelA: _ctx.$i18n.dimensionNames.height,
          labelB: _ctx.$i18n.dimensionNames.width
        }, null, 8, ["modelValue", "labelA", "labelB"])
      ]),
      _createVNode(TextNotice, {
        class: "text-dimension-inputs__full",
        severity: "notice"
      }, {
        icon: _withCtx(() => [
          _createVNode(InfoCircleDark)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.$i18n.text.height_notice), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})